/**
 * 사망 후 부활 장소 선택. 조작키는 docs/game-design.md 4.3·6장과 같게 둔다.
 */

import Phaser from 'phaser';
import { COLOR, TEXT_COLOR, UI_FONT } from './theme';

export class DeathOverlay {
  private readonly container: Phaser.GameObjects.Container;
  private readonly lostText: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene, onPick: (place: 'here' | 'town') => void) {
    const w = 420;
    const h = 220;
    const x = (scene.scale.width - w) / 2;
    const y = (scene.scale.height - h) / 2 - 40;

    this.container = scene.add.container(x, y).setVisible(false).setDepth(30);

    const g = scene.add.graphics();
    g.fillStyle(COLOR.panelEdge, 0.96);
    g.fillRoundedRect(-4, -4, w + 8, h + 8, 12);
    g.fillStyle(COLOR.panel, 0.98);
    g.fillRoundedRect(0, 0, w, h, 10);
    g.lineStyle(2, COLOR.panelLight, 1);
    g.strokeRoundedRect(0, 0, w, h, 10);
    this.container.add(g);

    const title = scene.add.text(w / 2, 22, '쓰러졌습니다', {
      fontFamily: UI_FONT,
      fontSize: '22px',
      color: TEXT_COLOR.gold,
    });
    title.setOrigin(0.5, 0);

    this.lostText = scene.add.text(w / 2, 62, '', {
      fontFamily: UI_FONT,
      fontSize: '14px',
      color: TEXT_COLOR.warn,
      align: 'center',
      wordWrap: { width: w - 32, useAdvancedWrap: true },
    });
    this.lostText.setOrigin(0.5, 0);

    const here = scene.add.text(w / 2, 110, '1  이 맵에서 부활', {
      fontFamily: UI_FONT,
      fontSize: '16px',
      color: TEXT_COLOR.bright,
      align: 'center',
      wordWrap: { width: w - 32, useAdvancedWrap: true },
    });
    here.setOrigin(0.5, 0);
    here.setInteractive({ useHandCursor: true });
    here.on('pointerdown', () => onPick('here'));

    const town = scene.add.text(w / 2, 146, '2  헤네시스 마을에서 부활', {
      fontFamily: UI_FONT,
      fontSize: '16px',
      color: TEXT_COLOR.bright,
      align: 'center',
      wordWrap: { width: w - 32, useAdvancedWrap: true },
    });
    town.setOrigin(0.5, 0);
    town.setInteractive({ useHandCursor: true });
    town.on('pointerdown', () => onPick('town'));

    const hint = scene.add.text(w / 2, 186, '경험치는 이미 깎였습니다', {
      fontFamily: UI_FONT,
      fontSize: '13px',
      color: TEXT_COLOR.dim,
      align: 'center',
      wordWrap: { width: w - 32, useAdvancedWrap: true },
    });
    hint.setOrigin(0.5, 0);

    this.container.add([title, this.lostText, here, town, hint]);
  }

  show(lostExp: number, exp: number, need: number): void {
    const lost = lostExp > 0 ? `경험치 −${lostExp.toLocaleString()}` : '경험치 손실 없음';
    this.lostText.setText(`${lost}   (${exp.toLocaleString()} / ${need.toLocaleString()})`);
    this.container.setVisible(true);
  }

  hide(): void {
    this.container.setVisible(false);
  }

  get visible(): boolean {
    return this.container.visible;
  }
}
